import styled, { css } from 'styled-components';
import { agAddressCardHeight } from '~/helpers/agAddressCardHeight';

const PlanCardStyled = styled.div.attrs({
  className: 'plan-card',
})`
  ${({ theme, singleProduct, hasHover, expanded, agAddressType, bannerEnabled, hideBannerDisplay, isCopper }) => {
    const { colors, fonts, media } = theme;

    return css`
      flex: 1 1 50%;
      border-radius: 8px 8px 0 0;
      box-shadow: 0 0.25rem 0.25rem rgba(0 0 0 / 20%);
      ${!singleProduct &&
      css`
        height: ${
          expanded
            ? agAddressCardHeight(agAddressType, 'open', bannerEnabled, hideBannerDisplay)
            : agAddressCardHeight(agAddressType, 'close', bannerEnabled, hideBannerDisplay)
        }};
        max-width: 350px;
      `}
      position: relative;

      ${hideBannerDisplay &&
      css`
        margin-top: 50px;
      `}
      ${singleProduct &&
      `
      display: flex;
      width: 100%;
      `};

      ${media.tablet.only} {
        ${!singleProduct ? `flex: 0 1 calc(50% - 16px);` : ''}
      }

      ${!bannerEnabled &&
      css`
        margin-top: 50px;
      `}

      .ag-mn {
        .plan-card {
          &__legal {
            max-width: 85%;
          }
        }
      }

      .plan-card {
        &__banner {
          align-items: center;
          background-color: ${colors.primary.whiteSmoke};
          display: flex;
          flex-direction: column;
          font-size: 16px;
          font-weight: 700;
          justify-content: center;
          height: 52px;
          letter-spacing: -0.25px;
          padding-left: 0.5rem;
          padding-right: 0.5rem;
          position: relative;
          border-radius: 8px 8px 0 0;
          ${hideBannerDisplay && `display: none`};

          small {
            display: flex;
            align-items: center;
            justify-content: center;
            margin-top: 2px;

            span {
              color: ${colors.primary.red};
              font-weight: 700;
              margin-right: 2px;
            }

            .tooltip {
              svg {
                height: 10px;
              }

              .tooltip-button {
                margin: 0;
              }
            }
          }

          &-headline {
            color: ${colors.primary.darkBlue};
            text-align: center;
            font-weight: 700;
            ${media.tablet.down} {
              width: 76%;
              text-align: center;
            }
          }
          &-text {
            &--bold {
              font-weight: 700;
            }
          }
          &-legal {
            color: ${colors.primary.darkBlue};
            font-size: 10px;
            font-weight: 400;
          }
        }
        &__banner-hover-container {
          box-shadow: 0px 0px 18px -12px ${colors.primary.gray};
          border-radius: 10px;
          opacity: 0;
          position: absolute;
          padding: 0.25% 2%;
          width: 100%;
          left: 0;
          top: -55px;
          z-index: 9999;
          ${media.tablet.down} {
            display: none;
          }
        }
        &__banner-wrapper {
          ${singleProduct && `display: none;`}
        }
        &__banner-wrapper:hover {
          .plan-card__banner-hover-container {
            opacity: ${hasHover ? 1 : 0};
            transition: 0.25s ease-out;
          }
        }
        &__banner-hover-content {
          display: flex;
          align-items: center;
        }
        &__banner-hover-text {
          font-size: 14px;
          padding-left: 2%;
        }
        &__header {
          position: relative;
          background-color: ${colors.primary.darkBlue};
          color: ${colors.primary.white};
          display: flex;
          flex-direction: column;
          justify-content: center;
          min-height: 200px;
          text-align: center;
          ${singleProduct && `flex-basis: 23.5%;`}
        }
        &__2gig {
          padding-top: 64px;
        }
        &__best-value {
          font-size: 12px;
          font-weight: 500;
          background-color: ${colors.tertiary.teal};
          color: ${colors.primary.black};
          text-align: center;
          padding: 8px 0;
          margin-top: auto;
        }
        &__product-type {
          border-radius: 4px;
          display: inline-block;
          font-size: 12px;
          font-weight: 700;
          padding: 4px 8px;
          span {
            padding: 0 8px;
            &:first-child {
              /* The 1px extra offsets the 1px right border on the element next to it */
              padding-right: 9px;
            }
          }
          svg {
            fill: ${colors.primary.white};
            height: 9px;
            margin-right: 0;
            width: 15px;
          }
        }
        &__type-voice {
          border-left: 1px solid ${colors.primary.red};
        }
        &__speed {
          font-size: 1.5rem;
          font-weight: 700;
          margin-bottom: 0.75rem;

          small {
            font-size: 0.75rem;
            font-weight: 500;
            display: block;
            margin-top: 0.25rem;
          }

          .icon--fill-wifi {
            fill: ${colors.primary.white};
          }
        }
        &__wifi {
          display: flex;
          justify-content: center;
          align-items: center;

          .icon--fill-wifi {
            width: 22px;
            height: auto;
            margin-right: 8px;

            path {
              fill: ${colors.primary.white};
            }
          }
        }
        &__body {
          color: ${colors.primary.darkBlue};
          gap: 16px;
          padding: 32px 20px;
          text-align: center;
          ${singleProduct &&
          `
            display: flex;
            align-items: center;
            width: 100%;
            ${media.desktop.only} { padding: 10px 20px; }
          `}

          ${media.tablet.down} {
            flex-direction: column;
          }

          .consumer-label {
            padding-top: 16px;
            border: 0;
            background: none;
            font-size: 0.75rem;
            text-decoration: underline;
            cursor: pointer;
          }
        }
        &__price-legal-container {
          margin-bottom: 8px;

          &.is-copper {
            width: 100%;
          }

          &.is-fiber {
            ${!singleProduct && `margin-bottom: 20px`}

            ${media.desktop.only} {
              &.ag-all {
                height: 130px;
              }

              &.ag-mn {
                height: 140px;
              }
            }
          }

          ${singleProduct &&
          `
            align-self: center;
            flex-basis: ${isCopper ? '45.33%' : '25%'} ;
            margin-bottom: 0;
          `}
        }

        &__price-container {
          display: flex;
          flex-direction: row;
          justify-content: center;
          align-items: flex-start;
          padding-bottom: 0.25rem;

          .pre {
            font-size: 1.5rem;
            font-weight: 700;
            transform: translateY(0.25rem);
          }

          .post {
            font-size: 1rem;
            padding-left: 0.15rem;
          }

          .annotation {
            font-size: 0.75rem;
          }
        }

        &__dollars {
          display: flex;
          flex-direction: column;
          font-size: 42px;
          font-weight: 700;
        }

        &__frequency {
          font-size: 11px;
          font-weight: 700;
          margin-top: 10px;

          sup {
            font-family: ${fonts.avenir};
            font-size: 7px;
            position: relative;
            top: -5px;
          }
        }
        &__full-price {
          color: ${colors.primary.gray};
          font-weight: 500;
          font-size: 12px;
          text-decoration-line: line-through;
          text-decoration-color: ${colors.primary.red};
        }
        &__legal {
          margin: auto;
          max-width: 70%;
        }
        &__features {
          text-align: left;
        }
        &__legal {
          &-headline {
            font-size: 12px;
            font-weight: 500;
          }
          &-text {
            color: ${colors.primary.darkBlue};
            font-size: 10px;
            margin-top: 0.25rem;
            line-height: 14px;
            padding-right: 1rem;
          }
        }
        &__features {
          font-size: 12px;
          font-weight: 300;
          line-height: ${!singleProduct && !expanded ? '14px' : ''};
          padding-bottom: 16px;
        }

        &__feature {
          align-items: center;
          display: flex;
          margin-bottom: 1rem;
          font-size: 0.75;
          font-weight: 500;
          line-height: 1.3;
          width: ${singleProduct && isCopper ? '80%' : ''};

          /* toggle any featureItem greater than 3 */
          ${!singleProduct &&
          `
          &:nth-child(n + 4) {
            display: ${expanded ? 'flex' : 'none'};
          }
          `}

          sup {
            line-height: 0;
          }

          strong {
            font-size: inherit;
            font-weight: inherit;
          }

          button {
            background: none;
            border: none;
            cursor: pointer;
            padding: 0;
            text-align: left;
            text-decoration: underline;
          }

          &-install__fine-print {
            display: block;
            font-size: 10px;
          }
          &-icon {
            flex: 0 0 18px;
            margin-right: 14px;
            fill: ${colors.primary.darkBlue};
            .icon {
              max-height: 22px;
              max-width: 25px;
            }
            .icon--fill-lightning-bolt {
              width: 24px;
              height: 24px;
              circle {
                fill: ${colors.primary.white};
              }
              path {
                fill: ${colors.secondary.black};
              }
            }
            .icon--fill-bolt {
              width: 18px;
              height: 18px;
              circle {
                fill: ${colors.primary.white};
              }
              path {
                fill: ${colors.secondary.black};
              }
            }

            icon--fill-headset {
              width: 24px;
            }
          }

          sup {
            font-size: 0.5rem;
          }
        }
        &__ctas {
          display: flex;
          gap: 9px;
          justify-content: center;
          margin-bottom: 24px;
          ${singleProduct &&
          `
            align-items: center;
            flex: 1 0 20%;
            flex-direction: column;
            margin-bottom: 0;
            order: 1;
        `}
          ${media.mobile.down} {
            flex-wrap: wrap;
          }

          button,
          a {
            flex-basis: 50%;
          }

          &.is-single {
            button,
            a {
              max-width: 230px;
              flex-basis: 100%;
            }
          }

          ${singleProduct &&
          `
              a {
                display: none;
              }
            `}
        }
        &__button {
          min-width: 229px;
          font-weight: 700;
          font-size: 18px;
          line-height: 1;
          max-height: 42px;
          padding: 12px 7px;
          text-transform: uppercase;
          width: 100%;
          ${media.tablet.only} {
            font-size: 14px;
            width: 600px;
            max-width: 600px;
          }
          ${media.mobile.down} {
            min-width: 229px;
            width: 229px;
          }
        }
        &__details {
          align-items: center;
          background-color: ${colors.tertiary.white};
          border-radius: 0 0 0.5rem 0.5rem;
          border: none;
          bottom: 0;
          cursor: pointer;
          display: flex;
          font-size: 12px;
          font-weight: 500;
          justify-content: center;
          left: 0;
          margin-bottom: 0;
          min-height: 50px;
          position: absolute;
          width: 100%;

          ${singleProduct && `display: none;`}
          .icon--fill-chevron-down {
            height: 10px;
            margin-left: 10px;
            width: 16px;
            ${expanded && `transform: rotate(0.5turn);`}
          }
        }
      }
    `;
  }}
`;

export default PlanCardStyled;
